export default {
    ENTER: 13,
    BACKSPACE: 8,
    SHIFT: 16,
    ESCAPE: 27,
    TAB: 9,
    WHITESPACE: 32,
};
